import { Keyboard, ScrollText } from "lucide-react";
import GameIcon from "./IconComponent/GameIcon";
import MenuIconTooltip from "./MenuIconTooltip";
import { useGameSessionNav } from "../contexts/GameSessionContext";
import { MENU_GAME_PREP_TOOLTIPS } from "../constants/menuTooltips";

export default function GamePrepNav() {
  const { prepNavState, handlePrepScreenChange } = useGameSessionNav();

  if (!prepNavState.visible) return null;

  const { screen } = prepNavState;

  return (
    <div className="menuFilterContainer game-prep-nav">
      <MenuIconTooltip
        tooltip={MENU_GAME_PREP_TOOLTIPS.difficulty}
        placement="left"
        portal
        className={screen === "difficulty" ? "filterIcon active" : "filterIcon"}
      >
        <GameIcon
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => handlePrepScreenChange("difficulty")}
          aria-label="Choisir la difficulté"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_GAME_PREP_TOOLTIPS.key}
        placement="left"
        portal
        className={screen === "key" ? "filterIcon active" : "filterIcon"}
      >
        <ScrollText
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => handlePrepScreenChange("key")}
          aria-label="Utilisation d'un parchemin"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_GAME_PREP_TOOLTIPS.shortcuts}
        placement="left"
        portal
        className={screen === "shortcuts" ? "filterIcon active" : "filterIcon"}
      >
        <Keyboard
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => handlePrepScreenChange("shortcuts")}
          aria-label="Raccourcis clavier des potions"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>
    </div>
  );
}
